/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MedicationMedicines from './medication-medicines';
import MedicationMedicinesDetail from './medication-medicines-detail';
import MedicationMedicinesUpdate from './medication-medicines-update';
import MedicationMedicinesDeleteDialog from './medication-medicines-delete-dialog';

const MedicationMedicinesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MedicationMedicines />} />
    <Route path="new" element={<MedicationMedicinesUpdate />} />
    <Route path=":id">
      <Route index element={<MedicationMedicinesDetail />} />
      <Route path="edit" element={<MedicationMedicinesUpdate />} />
      <Route path="delete" element={<MedicationMedicinesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicationMedicinesRoutes;
